import React from 'react';
import Cookies from 'js-cookie';
import _decode from 'jwt-decode';
import {upperFirst} from 'lib/stringUtils';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

import {Dialogue, Button, Text} from '@albert-io/atomic';

interface Props {
  className: string;
  handleClose: () => void;
  students: any[];
  syncClassroom: () => void;
  seatsRemaining: number;
  shouldShowHardCapWarning: boolean;
}

interface DecodedLaunchContextCookie {
  context_id: String;
  context_title: String;
  tool_platform_product_family_code: 'Canvas' | 'Schoology';
}

const InviteByLMS = ({
  className,
  handleClose,
  students,
  syncClassroom,
  seatsRemaining,
  shouldShowHardCapWarning
}: Props) => {
  const launchContextCookie = Cookies.get('lti_launch_context');
  const launchContextDecoded = _decode(launchContextCookie) as DecodedLaunchContextCookie;
  const lmsPlatformName = launchContextDecoded.tool_platform_product_family_code || 'LMS';
  const lmsClassName = launchContextDecoded.context_title || '';

  return (
    <Dialogue
      hideCloseBtn={false}
      className={className}
      size='m'
      handleClose={handleClose}
      paddingLevel={0}
    >
      <Dialogue.Title size='xs' className='u-pad-t_2 u-pad-l_2'>
        Import from LMS
      </Dialogue.Title>
      {shouldShowHardCapWarning && <HardCapWarningBanner seatsRemaining={seatsRemaining} />}
      <Dialogue.Body className='u-pad_4'>
        <div className='u-display_flex u-flex-direction_column'>
          <Text bold>{upperFirst(lmsPlatformName)} class:</Text>
          <Text>{lmsClassName}</Text>
          <Text bold className='u-mar-b_2 u-mar-t_5'>
            Students to import:
          </Text>
          {students.map((item) => {
            const isStudent =
              item
                .get('roles')
                .includes('http://purl.imsglobal.org/vocab/lis/v2/membership#Learner') &&
              item.get('fields').get('name') !== 'Test Student';

            if (isStudent) {
              const hasEmail = !!item.get('fields').get('email');
              return (
                <div className='u-display_flex u-justify-content_space-between u-align-items_center u-pad-b_1'>
                  <div className='u-display_flex'>
                    <div className='u-display_flex u-flex-direction_column'>
                      <Text emphasis='high'>{item.get('fields').get('name')}</Text>
                    </div>
                  </div>
                  {hasEmail ? (
                    <Text emphasis='medium'>{item.get('fields').get('email')}</Text>
                  ) : (
                    <Text italic>No email address</Text>
                  )}
                </div>
              );
            }
            return null;
          })}
        </div>
      </Dialogue.Body>
      <Dialogue.BtnGroup className='u-pad-b_2 u-pad-r_2'>
        <Button color='secondary' onClick={() => handleClose()}>
          Cancel
        </Button>
        <Button onClick={() => syncClassroom()}>Import</Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

export default InviteByLMS;
